<template>
  <v-btn-toggle v-model="galleryView" dense mandatory>

    <v-btn :value="12" small icon>
      <v-icon class="grey--text text--darken-1">view_list</v-icon>
    </v-btn>

    <v-btn :value="6" small icon>
      <v-icon class="grey--text text--darken-1">view_module</v-icon>
    </v-btn>

    <v-btn :value="4" small icon>
      <v-icon class="grey--text text--darken-1">view_comfy</v-icon>
    </v-btn>
  </v-btn-toggle>
</template>

<script>
export default {
  name: "GalleryViewButtons",
  computed: {
    galleryView: {
      get() {
        return this.$store.getters.galleryView
      },
      set(val) {
        this.$store.commit('galleryView', val)
      }
    }
  }
}
</script>

<style scoped>

</style>
